import script from "./WinnerPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WinnerPopup.vue?vue&type=script&setup=true&lang=js"

import "./WinnerPopup.vue?vue&type=style&index=0&id=a0d5a350&scoped=true&lang=scss"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0d5a350"]])

export default __exports__